import React from 'react';
import { Link, ButtonV2 } from '@zola/zola-ui';
import styles from './styles.module.less';

export const AcessListDesign = ({ cardTypeLabel, handleOpenModal }) => (
  <Link
    className={styles.apManagementPage}
    arrow
    arrowPosition="postfix"
    onClick={handleOpenModal}
    role="button"
  >
    Get a Free Matching {cardTypeLabel} Sample
  </Link>
);

export const APWebsitePdp = ({ cardTypeLabel, handleOpenModal }) => {
  return (
    <div className={styles.apPdpPage}>
      <h2 className={styles.apPdpPageTitle}>Try a Free Matching {cardTypeLabel} Sample</h2>
      <p className={styles.apPdpPageText}>
        See and feel our design in person, printed with your names, wedding date, and photo.
      </p>
      <ButtonV2 variant="secondary" role="button" onClick={handleOpenModal}>
        Order a Free Sample
      </ButtonV2>
    </div>
  );
};

export const APWebsitePlp = ({ cardTypeLabel, handleOpenModal }) => (
  <div className={styles.apPlpPage}>
    <h2 className={styles.apPlpPageTitle}>Get a Free Matching {cardTypeLabel} Sample</h2>
    <p className={styles.apPlpPageText}>
      See and feel our design in person, printed with your names, wedding date, and photo.
    </p>
    <ButtonV2 variant="secondary" role="button" onClick={handleOpenModal}>
      Order a Free Sample
    </ButtonV2>
  </div>
);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleAccessPoint/SingleSampleAccessPointUI.jsx